import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex flex-row justify-center" };
const _hoisted_2 = { class: "flex flex-col flex-1 px-8 max-w-site-max-w sm:mt-40" };
const _hoisted_3 = { class: "flex flex-col mb-72" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.pricing')
};
import { ref } from 'vue';
import { useFullWidth } from '@/composables/useFullWidth';
import StartFree from '@/views/landing/StartFree.vue';
import Toggable from '@/components/Toggable.vue';
import PricingToggleableOptions from '@/components/pricing/PricingToggleableOptions.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'PricingPage',
    setup(__props) {
        const openFaq = ref({});
        const paymentPeriod = ref('annual');
        function handleFaqOpen(key) {
            openFaq.value[key] = !openFaq.value[key];
        }
        useFullWidth();
        return (_ctx, _cache) => {
            const _component_section_heading = _resolveComponent("section-heading");
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_section_heading, {
                            class: "font-bold text-primary-800",
                            heading: _ctx.$t('title')
                        }, null, 8, ["heading"]),
                        _createVNode(PricingToggleableOptions, {
                            "payment-period": paymentPeriod.value,
                            "onUpdate:payment-period": _cache[0] || (_cache[0] = ($event) => ((paymentPeriod).value = $event))
                        }, null, 8, ["payment-period"]),
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_section_heading, {
                                class: "font-bold text-primary-800",
                                align: "left",
                                heading: _ctx.$t('faqs.title'),
                                size: "text-4xl"
                            }, null, 8, ["heading"]),
                            _createVNode(Toggable, {
                                open: openFaq.value[1],
                                "onUpdate:open": _cache[1] || (_cache[1] = ($event) => ((openFaq.value[1]) = $event)),
                                title: _ctx.$t('faqs.first.question'),
                                onToggle: _cache[2] || (_cache[2] = ($event) => (handleFaqOpen(1)))
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('faqs.first.answer')), 1)
                                ], undefined, true),
                                _: 1
                            }, 8, ["open", "title"]),
                            _createVNode(Toggable, {
                                open: openFaq.value[2],
                                "onUpdate:open": _cache[3] || (_cache[3] = ($event) => ((openFaq.value[2]) = $event)),
                                title: _ctx.$t('faqs.second.question'),
                                onToggle: _cache[4] || (_cache[4] = ($event) => (handleFaqOpen(2)))
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('faqs.second.answer')), 1)
                                ], undefined, true),
                                _: 1
                            }, 8, ["open", "title"]),
                            _createVNode(Toggable, {
                                open: openFaq.value[3],
                                "onUpdate:open": _cache[5] || (_cache[5] = ($event) => ((openFaq.value[3]) = $event)),
                                title: _ctx.$t('faqs.third.question'),
                                onToggle: _cache[6] || (_cache[6] = ($event) => (handleFaqOpen(3)))
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('faqs.third.answer')), 1)
                                ], undefined, true),
                                _: 1
                            }, 8, ["open", "title"]),
                            _createVNode(Toggable, {
                                open: openFaq.value[4],
                                "onUpdate:open": _cache[7] || (_cache[7] = ($event) => ((openFaq.value[4]) = $event)),
                                title: _ctx.$t('faqs.fourth.question'),
                                onToggle: _cache[8] || (_cache[8] = ($event) => (handleFaqOpen(4)))
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('faqs.fourth.answer')), 1)
                                ], undefined, true),
                                _: 1
                            }, 8, ["open", "title"]),
                            _createVNode(Toggable, {
                                open: openFaq.value[5],
                                "onUpdate:open": _cache[9] || (_cache[9] = ($event) => ((openFaq.value[5]) = $event)),
                                title: _ctx.$t('faqs.fifth.question'),
                                onToggle: _cache[10] || (_cache[10] = ($event) => (handleFaqOpen(5)))
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('faqs.fifth.answer')), 1)
                                ], undefined, true),
                                _: 1
                            }, 8, ["open", "title"]),
                            _createVNode(Toggable, {
                                open: openFaq.value[6],
                                "onUpdate:open": _cache[11] || (_cache[11] = ($event) => ((openFaq.value[6]) = $event)),
                                title: _ctx.$t('faqs.sixth.question'),
                                onToggle: _cache[12] || (_cache[12] = ($event) => (handleFaqOpen(6)))
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('faqs.sixth.answer')), 1)
                                ], undefined, true),
                                _: 1
                            }, 8, ["open", "title"])
                        ]),
                        _createVNode(StartFree)
                    ])
                ])
            ]));
        };
    }
});
